import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class UserEmail extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline;
        overflow: hidden;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }

    return html`${this.entity.properties.email}`;
  }
}

window.customElements.define('user-email', UserEmail);
